// extracted by mini-css-extract-plugin
export var dropdown = "_qf-0";
export var imageWrapper = "_qf-3";
export var itemNameContainer = "_qf-1";
export var productImage = "_qf-2";
export var spinnerWrapper = "_qf-4";